export const MuiTextField = {
  styleOverrides: {
    root: {
      '.MuiInputBase-root': {
        borderRadius: '8px',
      },
      '.MuiInputBase-root.Mui-disabled fieldset': {
        borderStyle: 'dotted',
      },
      '.MuiInputBase-input.Mui-disabled fieldset': {
        borderStyle: 'dotted',
      },
      '.MuiFormLabel-root.Mui-error:not(.MuiInputLabel-shrink)': {
        color: 'var(--text-secondary, #808080)',
      },
      '& input[type=number]': {
        MozAppearance: 'textfield',
      },
      '& input[type=number]::-webkit-outer-spin-button': {
        WebkitAppearance: 'none',
        margin: 0,
      },
      '& input[type=number]::-webkit-inner-spin-button': {
        WebkitAppearance: 'none',
        margin: 0,
      },

      '.MuiInputBase-multiline': {
        padding: 0,

        '.MuiInputBase-input': {
          padding: '16.5px 14px',
        },
      },
    },
  },
}
